module.exports = __webpack_public_path__ + "static/media/chedli.fb640ded.webp";